import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { User } from ".";
import { Organization } from "./Organization";
import { Project } from "./Project";

@Entity()
export class ReportDownload {
  @PrimaryGeneratedColumn() id: number;

  @Column("int") userId: number;
  @ManyToOne(() => User)
  @JoinColumn()
  user: User;

  @Column("varchar") startDate: string;
  @Column("varchar") endDate: string;
  @Column("varchar") songsOrMasters: "Song" | "Master" | "All";
  @Column("varchar") orgType: "Commercial" | "Non-Commercial" | "Both";

  @Column("varchar", { nullable: true }) downloadType: "csv" | "pdf" | null;

  @Column("int", { nullable: true }) organizationId: number | null;

  @ManyToOne(() => Organization, organization => organization.reportDownloads)
  organization: Organization;

  @Column("int", { nullable: true }) projectId: number | null;

  @ManyToOne(() => Project, project => project.reportDownloads)
  project: Project;

  @Column("datetime")
  createdAt: Date;

  @Column("varchar", { nullable: true }) zipFileLocation: string | null;
}
